var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 324.385 324.385",
    style: {
      enableBackground: "new 0 0 324.385 324.385"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1093_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1094_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1304_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1305_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M245.381,228.832c-18.667-6.681-51.458-11.736-51.458-81.376h-29.23h-5.002 h-29.23c0,69.64-32.791,74.695-51.458,81.376c0,47.368,68.832,48.824,80.688,53.239v1.537c0,0,0.922-0.188,2.501-0.68 c1.579,0.492,2.501,0.68,2.501,0.68v-1.537C176.549,277.657,245.381,276.2,245.381,228.832z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1306_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M193.923,147.457h-29.23h-2.417v135.497c1.526,0.472,2.417,0.654,2.417,0.654 v-1.537c11.856-4.415,80.688-5.871,80.688-53.239C226.714,222.152,193.923,217.097,193.923,147.457z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1307_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1308_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1309_",
    style: {
      fill: "#F3DBC4"
    },
    d: "M162.194,169.619c-27.454,0-48.409-23.119-57.799-40.456 s-15.888-79.445,4.34-106.897c19.808-26.883,53.459-13.838,53.459-13.838s33.649-13.045,53.458,13.838 c20.226,27.452,13.726,89.56,4.335,106.897C210.595,146.5,189.643,169.619,162.194,169.619z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1310_",
    style: {
      fill: "#EDCEAE"
    },
    d: "M215.653,22.266C196.395-3.867,164.065,7.729,162.276,8.397v161.22 c27.408-0.046,48.329-23.135,57.712-40.454C229.378,111.826,235.879,49.719,215.653,22.266z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1311_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_65_",
    transform: "matrix(0.3543 -0.9351 0.9351 0.3543 49.5754 275.6114)",
    style: {
      fill: "#EDCEAE"
    },
    cx: 224.366,
    cy: 101.907,
    rx: 17.187,
    ry: 10.048
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_64_",
    transform: "matrix(0.3543 0.9351 -0.9351 0.3543 159.8797 -27.7212)",
    style: {
      fill: "#F3DBC4"
    },
    cx: 100.014,
    cy: 101.913,
    rx: 17.187,
    ry: 10.048
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1312_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1313_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1314_",
    style: {
      fill: "#A7B8D4"
    },
    d: "M204.186,91.841h-27.689c-1.185,0-2.356,0.243-3.431,0.713l-10.874,3.873 l-10.874-3.873c-1.075-0.47-2.246-0.713-3.431-0.713h-27.688c-5.509,0-7.411,9.474-7.411,9.474 c0,12.532,9.191,22.692,23.756,22.692c8.882,0,17.409-9.44,22.649-17.081h6c5.24,7.641,13.768,17.081,22.649,17.081 c14.565,0,23.756-10.16,23.756-22.692C211.597,101.315,209.696,91.841,204.186,91.841z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1315_",
    style: {
      fill: "#8AA4C2"
    },
    d: "M204.186,91.841h-27.689c-1.185,0-2.356,0.243-3.431,0.713l-10.791,3.843v10.529 h2.917c5.24,7.641,13.768,17.081,22.649,17.081c14.565,0,23.756-10.16,23.756-22.692 C211.597,101.315,209.696,91.841,204.186,91.841z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1316_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1319_",
    style: {
      fill: "#A0756F"
    },
    d: "M218.585,18.112c-2.16,0.019-25.469-13.121-41.382-16.355 c-18.766-3.814-18.777-0.529-26.02,1.516C134.348-9.076,92.679,27.924,92.679,35.568c0,37.112-2.768,40.697,1.715,53.646 s8.466,23.407,8.466,23.407s2.988,9.819,2.988-10.697c0-55.843,2.805-3.574,100.009-46.537 c19.157-8.467,9.145,19.96,11.137,40.379s2.988,16.854,2.988,16.854s3.984-10.458,8.466-23.407 C232.931,76.265,237.937,17.942,218.585,18.112z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1322_",
    style: {
      fill: "#8C6762"
    },
    d: "M218.585,18.112c-2.16,0.019-25.469-13.121-41.382-16.355 c-7.314-1.487-11.773-1.892-14.928-1.716v70.406c11.865-2.755,26.208-7.381,43.581-15.06c19.157-8.467,9.145,19.96,11.137,40.379 c1.992,20.419,2.988,16.854,2.988,16.854s3.984-10.458,8.466-23.407C232.931,76.265,237.937,17.942,218.585,18.112z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1323_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_51_",
    x: 105.138,
    y: 223.924,
    style: {
      fill: "#B7CAE9"
    },
    width: 114.108,
    height: 100.325
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1324_",
    x: 162.276,
    y: 223.924,
    style: {
      fill: "#96B3D4"
    },
    width: 56.971,
    height: 100.325
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1325_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1326_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      fill: "#367992"
    },
    d: "M82.285,212.791c6.042-3.641,19.69-7.43,26.844-9.196 c5.953-1.488,3.486,14.829,5.684,35.763c2.277,21.677,19.285,85.027,19.285,85.027H41.681v-40.681 C41.681,253.273,59.058,226.741,82.285,212.791z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    style: {
      fill: "#358BA2"
    },
    d: "M123.096,193.924c0,0-32.452,8.501-39.684,18.626 c-7.232,10.124-11.571,23.865-11.571,23.865l28.204,10.124l-20.887,20.344l28.15,57.366h26.791c0,0-20.207-72.454-20.67-97.992 C113.277,217.89,123.096,193.924,123.096,193.924z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1327_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1332_",
    style: {
      fill: "#2F697E"
    },
    d: "M242.099,212.791c-6.042-3.641-19.69-7.43-26.844-9.196 c-5.953-1.488-3.486,14.829-5.684,35.763c-2.277,21.677-19.285,85.027-19.285,85.027h92.418v-40.681 C282.704,253.273,265.327,226.741,242.099,212.791z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1335_",
    style: {
      fill: "#367992"
    },
    d: "M201.289,193.924c0,0,32.452,8.501,39.684,18.626 c7.232,10.124,11.571,23.865,11.571,23.865l-28.204,10.124l20.887,20.344l-28.15,57.366h-26.791c0,0,20.207-72.454,20.669-97.992 C211.107,217.89,201.289,193.924,201.289,193.924z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1336_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_33_",
    transform: "matrix(0.3543 -0.9351 0.9351 0.3543 49.5754 275.6114)",
    style: {
      fill: "#EDCEAE"
    },
    cx: 224.366,
    cy: 101.907,
    rx: 17.187,
    ry: 10.048
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_32_",
    transform: "matrix(0.3543 0.9351 -0.9351 0.3543 159.8797 -27.7212)",
    style: {
      fill: "#F3DBC4"
    },
    cx: 100.014,
    cy: 101.913,
    rx: 17.187,
    ry: 10.048
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.88e90dc62c88d95e859f666993f6fe19.svg";
export { ForwardRef as ReactComponent };